<template>
    <Modal
        :enable-close="false"
        v-model="mostrarModal"
        :title="'Sincronización Empresas'"
        :modal-style="{ 'min-width': '300px', 'max-width': '640px', 'max-height':'580px'}"
        @before-open="beforeOpen" @before-close="beforeClose"
        @close="cerrarModal"
  >
    <CRow>
        <CCol :col="isActualizandoEmpresas ? 5 : 12">
            <CButton
                v-tippy="getBaseTippy(`Sincronizar Empresas de ${(tipoBd=='CONTA'?'Contabilidad':'Remuneraciones')}`)"
                class="btnPrincipalVapp mb-1"
                variant="ghost"
                size="sm"
                color="success"
                @click="actualizarEmpresas"
                :disabled="isActualizandoEmpresas">
                <CIcon :content="$options.freeSet.cilLoopCircular" :class="isActualizandoEmpresas ? 'imgr' : ''" /> <span>Sincronizar Todas las Empresas</span>
            </CButton>
            <CButton
                class="ml-1 mb-1"
                style="width:auto"
                size="sm"
                color="danger"
                @click="cancelarActualizaciones"
                v-show="isActualizandoEmpresas"
                v-tippy="getBaseTippy(`Cancelar Actualización`)"
                >
                <CIcon :content="$options.freeSet.cilXCircle" />
            </CButton>
        </CCol>
        <CCol v-if="isActualizandoEmpresas"><!-- v-if="isActualizandoEmpresas"  v-show="getEmpresasActualzando().length > 0 || (empresasInfo.length - getEmpresasActualzando().length) <= empresasInfo.length">-->
            
            <span>
                <CProgress
                    v-tippy="getBaseTippy(`${empresasFinalizadas.length} / ${empresasInfo.length } Sincronizadas, faltan (${ (empresasFinalizadas <= 10 ? getEmpresasActualzando().join(', ') : getEmpresasActualzando().slice(0, 10).join(', ')+'...') })`)"
                    style="width: 50%;"
                    :value="(getEmpresasActualzando().length>0) ? parseFloat(((empresasFinalizadas.length/empresasInfo.length) * 100)): 0"
                    :precision="2" 
                    show-percentage 
                    :animated="true"
                    :color="((empresasInfo.length-getEmpresasActualzando().length) == empresasInfo.length)?'success':'warning'"
                />
            </span>
            <span>
                ({{ empresasFinalizadas.length}}/{{ empresasInfo.length }})
            </span>
        </CCol>
    </CRow>
    <CRow>
        <CCol md="12">Última Sincronizacion: 
            <span class="text-capitalize" :class="$utils.colorDiferenciaFecha(this.ultActualizacion)">
                {{ formatearFecha(ultActualizacion) }}
                ({{ $utils.calcularDifecenciaDias(ultActualizacion) }})
            </span>
            
        </CCol>
    </CRow>
    <CRow v-show="mostrarSugerencia">
        <CCol md="12"><span class="text-capitalize" :class="$utils.colorDiferenciaFecha(this.ultActualizacion)">**Ha pasado mucho tiempo sin sincronizar, le sugerimos sincronizar su información</span></CCol>
    </CRow>

    <!--<CRow>
        <CCol col="10">
            <CInput
                label="Buscar Empresa:"
                style="margin-top:0"
                v-model="filtroTexto"
                type="text"
                horizontal
                @input="filtrarCliente"
            />
        </CCol>
    </CRow>-->
    <CRow>
        <CCol>
            
            <tablaEmpresasActualizacion class="mb-2" :empresas="empresasInfo" :tipoBd="tipoBd" :loadingEmpresas="loadingEmpresas" @refreshFechaActualizacion="refreshFechaActualizacion" />
        </CCol>
    </CRow>

    <div class="vm-footer">
        <CRow>
            <CCol>
                <CButton
                    class="btnPrincipalVapp float-right"
                    @click="cerrarModal"
                >Cerrar</CButton>
            </CCol>
        </CRow>
    </div>

  </Modal>
    
  
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    
    import VueModal from "@kouts/vue-modal";
    import "@kouts/vue-modal/dist/vue-modal.css";
    import tablaEmpresasActualizacion from "@/views/utils/componentes/TablaEmpresasActualizacion"; 

    import * as util from '@/views/utils/utilsFunctions'
    import { freeSet } from "@coreui/icons";

    import bodyScroll from 'body-scroll-freezer'

    export default {
        name: "ModalEmpresasInfo",
        freeSet,
        props: {
            mostrarModal: Boolean,
            ultActualizacion: String,
            empresasInfo: Array,
            tipoBd: String,
            mostrarSugerencia: Boolean,
            isActualizandoEmpresas: Boolean,
            empresasFinalizadas: Array,
            loadingEmpresas: Boolean
        },
        components: {
            Modal: VueModal,
            tablaEmpresasActualizacion,
        },
        data() {
            return {
                filtroTexto: "",
                
                

            };
        },
        created: function () {
        },
        beforeMount() {
        },
        mounted(){
            bodyScroll.init()
        },
        methods: {
            beforeOpen() {
                bodyScroll.freeze()
            },
            beforeClose() {
                bodyScroll.unfreeze()
            },
            getEmpresasActualzando: function(){
                let empActualizando = []
                this.empresasInfo.forEach(item => {
                    if('actualizando' in item){
                        if(item.actualizando){
                            empActualizando.push(item.codEmpresa)
                        }
                    }

                })
                return empActualizando
            },

            actualizarEmpresas: function(){
                this.$emit("actualizarEmpresas")
            },
            cerrarModal: function(){
                this.$emit("cerrarModal")
            },
            formatearFecha: function(fecha){
                return util.formatFechaNormal(fecha)
            },

            filtrarCliente: function(){
                if(this.filtroTexto == ''){
                    return this.empresasInfo
                } else {
                    /*return this.clientesData.filter(item => {
                        return Object.values(item).some(val => String(val).toLowerCase().includes(this.filtroTexto.toLowerCase()));
                    });*/
                    let filtro = this.empresasInfo.filter(item => 
                        this.validarCampo(item.idEmpresa) ||
                        this.validarCampo(item.rutEmpresa) ||
                        this.validarCampo(this.$utils.formatearRut(item.rutEmpresa)) ||
                        this.validarCampo(item.nombreEmpresa) ||
                        this.validarCampo(item.codEmpresa)
                    )
                    return filtro
                }


            },
            validarCampo: function(campoValidar){
                if (!this.filtroTexto || !campoValidar) {
                    return false
                }
                return campoValidar.toLowerCase().includes(this.filtroTexto.toLowerCase())
            },
            cancelarActualizaciones: function(){
                this.$emit("cancelarActualizacion")
            },
            refreshFechaActualizacion: function(){
                this.$emit("refreshFechaActualizacion")
            }
        },
    };
</script>